import { User } from '../user';
import { JobRecruiter } from '../jobRecruiterMapping';


export class JobRecruiterMappingSerializer {
    fromJson(json: any): JobRecruiter {
        const data = new JobRecruiter();
        data.id = json.id;
        data.user = json.user;
        data.recruiterComment = json.comment;
        data.jobId = json.job ? json.job["id"] : json.jobId;
        data.startDate = json.startDate;
        data.endDate = json.endDate;
        data.expectedOffer = json.expectedOffer;
        data.expectedJoining = json.expectedJoining;
        data.position = json.position_assigned;
        data.deleted = json.deleted;
        return data;
    }

    toJson(data: JobRecruiter): any {
        return {
            user:data.user,
            recruiterComment: data.recruiterComment,
            jobId :data.jobId,
            startDate: data.startDate,
            endDate: data.endDate,
            expectedOffer: data.expectedOffer,
            expectedJoining: data.expectedJoining,
            position: data.position,
            id: data.id,
            deleted: data.deleted
        };
    }
}